import DodonesResolverDay from 'site/dodones_resolver/Day'
import DodoablesIndex from 'site/dodoables/Index'
import BirlIndex from 'site/birl/Index'
import Menu from 'site/layout/Menu'
import BirlExercisesIndex from 'site/birl/exercises/Index'

export default () => {
  return (
    <HashRouter>
      <div id="site">
        <Menu />
        <div className="flex-1 subtle-gray-transparent-box p-d fcol">
          <Routes>
            <Route path="/" element={<DodonesResolverDay />} />
            <Route path="/birl" element={<BirlIndex />} />
            <Route path="/birl/exercises" element={<BirlExercisesIndex />} />
            <Route path="/dodoables" element={<DodoablesIndex />} />
          </Routes>
        </div>
      </div>
    </HashRouter>
  )
}
